

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CzrzUVGP.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/CvggxNKg.js","_app/immutable/chunks/DXxkZ4MO.js","_app/immutable/chunks/Cc9MKd4K.js","_app/immutable/chunks/aFTmJgMS.js","_app/immutable/chunks/BgXaETc1.js"];
export const stylesheets = [];
export const fonts = [];
